import React, { useState } from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';
import LoginWithEmail from '@/screens/auth/login-with-email';
import SignupWithEmail from '@/screens/auth/signup-with-email';
import { SocialAuth } from '@/screens/auth/social-auth';
import { useSession } from 'next-auth/react';
import AuthBaseForm from '../auth/auth-base-form';
import { Dialog, DialogContent, DialogTrigger } from '../ui/dialog';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';

type AuthModalProps = {
  children: React.ReactNode;
  authType?: 'login' | 'signup';
};

export const AuthModal = ({ children, authType = 'login' }: AuthModalProps) => {
  const isMobile = useIsMobile();
  const [currentAuthType, setCurrentAuthType] = useState(authType);

  const { data } = useSession();

  if (data) {
    return children;
  }

  if (isMobile) {
    return (
      <Sheet>
        <SheetTrigger asChild>{children}</SheetTrigger>
        <SheetContent side='bottom' className='p-0 border-none shadow-none bg-transparent'>
          <AuthBaseForm title={currentAuthType}>
            {/* {currentAuthType === 'login' && <LoginWithEmail />}
            {currentAuthType === 'signup' && <SignupWithEmail />} */}
            <SocialAuth
              pageType={currentAuthType}
              onModalCallBack={() =>
                setCurrentAuthType(currentAuthType === 'login' ? 'signup' : 'login')
              }
            />
          </AuthBaseForm>
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className='w-auto p-0 border-none bg-transparent shadow-none outline-none max-sm:w-full'>
        <AuthBaseForm title={currentAuthType}>
          {process.env.NEXT_PUBLIC_SERVER === 'vercel' && (
            <>
              {currentAuthType === 'login' && <LoginWithEmail />}
              {currentAuthType === 'signup' && <SignupWithEmail />}
            </>
          )}
          <SocialAuth
            pageType={currentAuthType}
            onModalCallBack={() =>
              setCurrentAuthType(currentAuthType === 'login' ? 'signup' : 'login')
            }
          />
        </AuthBaseForm>
      </DialogContent>
    </Dialog>
  );
};
